import DeferredValueTimeline from '../DeferredValueTimeline';

export default function SingleClick() {
  return (
    <DeferredValueTimeline
      showInstructions
      video={{
        src: '/videos/use-deferred-value/deferred-01-single-click',
        length: 60 + 48,
      }}
      clicks={[26]}
      renders={[
        {
          type: 'initial',
          start: 26,
          end: 74,
          values: { count: 1 },
        },
      ]}
    />
  );
}
